import { Card, CardContent } from "./ui/card"
import { Star } from "lucide-react"


export function TestimonialCard({ quote, name, title, image, rating }) {
  return (
    <Card className="transition-all hover:shadow-md">
      <CardContent className="p-6">
        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className={`w-4 h-4 ${i < rating ? "text-primary fill-primary" : "text-gray-300"}`} />
          ))}
        </div>
        <p className="mb-6 italic">&ldquo;{quote}&rdquo;</p>
        <div className="flex items-center">
          {/* <div className="relative w-12 h-12 mr-4 overflow-hidden rounded-full">
            <img src={image || "/placeholder.svg"} alt={name} className="object-cover w-full h-full" />
          </div> */}
          <div>
            <h4 className="font-bold">{name}</h4>
            <p className="text-sm text-muted-foreground">{title}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
